import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from 'src/app/feature/modules/dynamic-pages/components/main/main.component';
import {ContentResolver} from 'src/app/feature/modules/dynamic-pages/resolver/content.resolver';

const routes: Routes = [{
  path: ':id',
  component: MainComponent,
  resolve: {
    content: ContentResolver
  },
  data: {revalidate: 60},
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DynamicPagesRoutingModule {
}
